#ifdef USE_MARBLE

#define NUM_OCTAVES 20

vec2 domainWarp(vec2 coords) {
    float amplitude = marbleAmplitude;
    float accumulatedNoise = 0.0;
    vec2 noiseCoords = coords + float(dieType);

    for (int i = 0; i < NUM_OCTAVES; i++) {
        noiseCoords += iGlobalTime * marbleTiming;
        accumulatedNoise += amplitude * texture2D(marbleNoiseTexture, noiseCoords).r;
        amplitude *= marbleAmplitude;
        noiseCoords *= 2.0;
    }

   return vec2(coords.x, coords.y + accumulatedNoise);
}

#endif
